import { createStyles, FormControl, FormHelperText, InputLabel, List, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../../helpers.js";
import { renderIconDefault } from "../icon.js";
import { DefaultAvatarTemplate } from "./default-avatar-template.js";
const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    label: {
      position: 'static',
      marginBottom: '4px'
    },
    listContainer: {
      display: 'block',
      padding: 0
    },
    centeredVertical: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center'
    }
  });
});
export const Avatar = props => {
  var _props$fieldValue, _props$repository, _props$repository2, _props$fieldValue2;
  const classes = useStyles();
  const [fieldValue, setFieldValue] = useState(((_props$fieldValue = props.fieldValue) === null || _props$fieldValue === void 0 ? void 0 : _props$fieldValue.Url) || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '');
  const AvatarTemplate = props.avatarTemplateOverride || DefaultAvatarTemplate;
  return props.actionName === 'new' || props.actionName === 'edit' ? /*#__PURE__*/React.createElement(FormControl, {
    className: classes.root,
    key: props.settings.Name,
    component: 'fieldset',
    required: props.settings.Compulsory
  }, !props.hideLabel && /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true,
    htmlFor: props.settings.Name,
    className: classes.label
  }, props.settings.DisplayName), /*#__PURE__*/React.createElement(List, {
    dense: true,
    className: classes.listContainer
  }, /*#__PURE__*/React.createElement(AvatarTemplate, {
    repositoryUrl: (_props$repository = props.repository) === null || _props$repository === void 0 ? void 0 : _props$repository.configuration.repositoryUrl,
    add: () => props.handleAdd({
      setAvatar: setFieldValue
    }),
    remove: props.handleRemove,
    actionName: props.actionName,
    readOnly: props.settings.ReadOnly,
    url: fieldValue,
    content: props.content,
    renderIcon: props.renderIcon ? props.renderIcon : renderIconDefault
  })), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description)) : /*#__PURE__*/React.createElement("div", {
    className: classes.centeredVertical
  }, /*#__PURE__*/React.createElement(List, {
    dense: true,
    className: classes.listContainer
  }, /*#__PURE__*/React.createElement(AvatarTemplate, {
    repositoryUrl: (_props$repository2 = props.repository) === null || _props$repository2 === void 0 ? void 0 : _props$repository2.configuration.repositoryUrl,
    url: (_props$fieldValue2 = props.fieldValue) === null || _props$fieldValue2 === void 0 ? void 0 : _props$fieldValue2.Url,
    content: props.content,
    actionName: "browse",
    renderIcon: props.renderIcon ? props.renderIcon : renderIconDefault
  })), /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true,
    htmlFor: props.settings.Name,
    style: {
      paddingTop: '9px',
      transformOrigin: 'top center'
    }
  }, props.settings.DisplayName));
};
//# sourceMappingURL=avatar.js.map